"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignFromAccountRaw = exports.assignToAccountRaw = exports.fromBitcoinResourcesRaw = exports.toBitcoinResourcesRaw = exports.fromBitcoinOutputRaw = exports.toBitcoinOutputRaw = exports.fromBitcoinInputRaw = exports.toBitcoinInputRaw = void 0;
const bignumber_js_1 = require("bignumber.js");
const wallet_btc_1 = __importDefault(require("./wallet-btc"));
function toBitcoinInputRaw({ address, value, previousTxHash, previousOutputIndex, }) {
    return [address, value ? value.toString() : undefined, previousTxHash, previousOutputIndex];
}
exports.toBitcoinInputRaw = toBitcoinInputRaw;
function fromBitcoinInputRaw([address, value, previousTxHash, previousOutputIndex,]) {
    return {
        address: address || undefined,
        value: value ? new bignumber_js_1.BigNumber(value) : undefined,
        previousTxHash: previousTxHash || undefined,
        previousOutputIndex,
    };
}
exports.fromBitcoinInputRaw = fromBitcoinInputRaw;
function toBitcoinOutputRaw({ hash, outputIndex, blockHeight, address, value, rbf, isChange, }) {
    return [hash, outputIndex, blockHeight, address, value.toString(), rbf ? 1 : 0, isChange ? 1 : 0];
}
exports.toBitcoinOutputRaw = toBitcoinOutputRaw;
function fromBitcoinOutputRaw([hash, outputIndex, blockHeight, address, value, rbf, isChange,]) {
    return {
        hash,
        outputIndex,
        blockHeight: blockHeight || undefined,
        address: address || undefined,
        value: new bignumber_js_1.BigNumber(value),
        rbf: !!rbf,
        isChange: !!isChange,
    };
}
exports.fromBitcoinOutputRaw = fromBitcoinOutputRaw;
function toBitcoinResourcesRaw(r) {
    return {
        utxos: r.utxos.map(toBitcoinOutputRaw),
        walletAccount: r.walletAccount && wallet_btc_1.default.exportToSerializedAccountSync(r.walletAccount),
    };
}
exports.toBitcoinResourcesRaw = toBitcoinResourcesRaw;
function fromBitcoinResourcesRaw(r) {
    return {
        utxos: r.utxos.map(fromBitcoinOutputRaw),
        walletAccount: r.walletAccount && wallet_btc_1.default.importFromSerializedAccountSync(r.walletAccount),
    };
}
exports.fromBitcoinResourcesRaw = fromBitcoinResourcesRaw;
function assignToAccountRaw(account, accountRaw) {
    const bitcoinAccount = account;
    if (bitcoinAccount.bitcoinResources) {
        accountRaw.bitcoinResources = toBitcoinResourcesRaw(bitcoinAccount.bitcoinResources);
    }
}
exports.assignToAccountRaw = assignToAccountRaw;
function assignFromAccountRaw(accountRaw, account) {
    const bitcoinResourcesRaw = accountRaw.bitcoinResources;
    if (bitcoinResourcesRaw)
        account.bitcoinResources = fromBitcoinResourcesRaw(bitcoinResourcesRaw);
}
exports.assignFromAccountRaw = assignFromAccountRaw;
//# sourceMappingURL=serialization.js.map